var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var g0 = _vm.categorys.length
  var g1 = _vm.listData.detail && _vm.categorys.length > 0
  var g2 = _vm.listData.detail && _vm.categorys.length > 0
  var g3 = !_vm.loading ? _vm.listData.list.length == 0 && !_vm.loading : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }